import React, { useEffect, useState } from "react";
import axiosHttp from "../handlers/AxiosHandler";

import CAR from "../../../Images/customer/policy-car.svg";
import TWO from "../../../Images/customer/policy-bike.svg";
import HLT from "../../../Images/customer/policy-health.svg";
import { NavLink } from "react-router-dom";
import "./Recent.css";
import axios from "axios";
import AddRenewPolicy from "../RenewPolicy/AddRenewPolicy";

const RecentlyViewedPlans = () => {
    const [loadingPolicyList, setLoadingPolicyList] = useState(true);
    const [policyList, setPolicyList] = useState([0]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        GetRecentPolicyList();
    }, []);

    function formatDateTime(dateString) {
        if (!dateString) return ""; // Handle empty or undefined date

        const date = new Date(dateString);

        // Extract time in 24-hour format
        const hours = date.getHours().toString().padStart(2, '0');
        const minutes = date.getMinutes().toString().padStart(2, '0');

        // Extract day, month (full name), and year
        const day = date.getDate();
        const month = date.toLocaleString('en-US', { month: 'long' }); // "February"
        const year = date.getFullYear();

        return `${hours}:${minutes}, ${day} ${month} ${year}`;
    }

    const updatedEnquiryArray = policyList.map(enquiry => ({
        ...enquiry,
        EnquiryDate: formatDateTime(enquiry.EnquiryDate) // Convert date format
    }));
    console.log(updatedEnquiryArray, "updatedEnquiryArray");

    const token = localStorage.getItem("smc-csp-token");
    const GetRecentPolicyList = async () => {
        try {
            const res = await axios.post(
                "https://www.smcinsurance.com/CustomerPanelApi/Api/Customers/GetRecentPolicyList",
                {},
                { headers: { Authorization: `Bearer ${token}` } }
            );
            console.log(res.data);
            if (res.status === 200 && res.data.StatusCode === 200) {
                setPolicyList(res.data.Data.RecentPolicies);
                setLoading(false)
            }
            setLoadingPolicyList(false);
        } catch (err) {
            setLoadingPolicyList(false);
        }
    };

    return (
        <>
            <h4>Continue from where you left...</h4>
            <div className="row">
                {loading ? (  // Show loader when loading
                    <div className="ProductLoader">
                    </div>
                ) : policyList && policyList?.length > 0 ?
                    <>
                        {policyList &&
                            policyList.length > 0 &&
                            updatedEnquiryArray.map((item, index) => (
                                <div className="col-md-3" key={index}>
                                    <div className="RecentPCard">
                                        <span className="Titile">
                                            {item.EnquiryType === "CAR" && "CAR "}
                                            {item.EnquiryType === "TWO" && "BIKE "}
                                            {item.EnquiryType === "HLT" && "HEALTH "}
                                            INSURANCE
                                        </span>
                                        <div className="ProIcon">
                                            {item.EnquiryType === "CAR" && <img alt="" src={CAR} />}
                                            {item.EnquiryType === "TWO" && <img alt="" src={TWO} />}
                                            {item.EnquiryType === "HLT" && <img alt="" src={HLT} />}
                                        </div>
                                        <div className="Desc">
                                            <p>
                                                {item.EnquiryDataCol1}
                                            </p>
                                            <p>
                                                {item.EnquiryType === "HLT" && "Sum Insured "}
                                                {item.EnquiryDataCol2}
                                            </p>
                                        </div>

                                        {policyList?.length > 0 && (
                                            <a class="RecentViewBtn" href={`https://www.smcinsurance.com/GetQuote?policyEnq=${item.EnquiryNo}`} target="_blank" rel="noopener noreferrer">
                                                <button>Plans <i class="fas fa-chevron-right"></i></button>
                                            </a>
                                        )}
                                        <div className="DateTime"><i className="fa fa-eye"></i> {item.EnquiryDate}</div>
                                    </div>
                                </div>
                            ))}
                    </>
                    :
                    <div className="row">
                        <div className="col-md-8">
                            <div className="alert alert-danger" role="alert">
                                <i className="fas fa-exclamation-triangle"></i> No policies available.
                            </div>
                        </div>
                        <div className="col-md-4">
                            <NavLink to="https://www.smcinsurance.com/">
                                <AddRenewPolicy />
                            </NavLink >
                        </div>
                    </div>
                }
            </div>
        </>
    );
};
export default RecentlyViewedPlans;
